export enum TagStyles {
  MHFO_STANDARD = 1,
  MHFO_SMALL = 2,
  MHFO_LARGE = 3,
  STAGING_STANDARD = 4,
  STAGING_LARGE = 5,
  STAGING_HOLD = 6,
  STAGINGRENTS_STICKER = 7,
}
